import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./store/App";

console.log(`AGD Store build: ${__BUILD_TIME__}`);

const container = document.getElementById("agd-store-root");
if (container) {
  container.style.removeProperty("visibility");
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
